import React from "react";

/**
 * ActivityCard - Bordered content box for activity descriptions
 * 
 * @param {React.ReactNode} children - Content to display inside the card
 */
const ActivityCard = ({ children }) => {
  return (
    <div className="border border-edge-border dark:border-edge-hex-3d3c3a px-3 py-3 sm:px-[12px] sm:py-[14px] bg-fill-hex-f0f4f9 dark:bg-fill-hex-222222 rounded-[10px]">
      <p className="text-sm whitespace-pre-line text-[14px] text-ink-hex-456175 dark:text-ink-hex-cccccc">
        {children}
      </p>
    </div>
  );
};

export default ActivityCard;
